import React, { useEffect, useState } from 'react';

import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

import { fetchGroupesActifsVisibles } from 'utils/ts-queries';
import { ApiGroupeItem } from 'types/apiReturns';

type Props = {
    value: number | null;
    onChange: (groupeId: number | null) => void;
    label?: string;
    required?: boolean;
    disabled?: boolean;
};

// Sélecteur de groupe de traitement autonome (charge la liste des GT actifs et visibles
// via l'API, sans passer par le store Redux).
export default function GroupeTraitementSelect({ value, onChange, label = 'Réaffectation au GT', required = false, disabled = false }: Props) {

    const [groupes, setGroupes] = useState<ApiGroupeItem[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        let annule = false;

        setLoading(true);
        fetchGroupesActifsVisibles()
            .then(items => {
                if (!annule) {
                    setGroupes(items);
                }
            })
            .catch(error => {
                console.error('fetchGroupesActifsVisibles : ', error);
            })
            .finally(() => {
                if (!annule) {
                    setLoading(false);
                }
            });

        return () => { annule = true; };
    }, []);

    return (
        <TextField
            select
            label={label}
            value={value ?? ''}
            onChange={event => {
                const val = event.target.value;
                onChange(val === '' ? null : Number(val));
            }}
            required={required}
            disabled={disabled || loading}
            fullWidth
        >
            {groupes.map(groupe => (
                <MenuItem key={groupe.id} value={groupe.id}>
                    {groupe.libelle}
                </MenuItem>
            ))}
        </TextField>
    );
}
